export function dayDifference(updatedOn){
    let createdDate = new Date(updatedOn);
    let today = new Date();

    const oneSecond = 1000;
    const oneMinute = 60 * oneSecond;
    const oneHour = 60 * oneMinute;
    const oneDay = 24 * oneHour;

    const timeDiff = today.getTime() - createdDate.getTime();

    if (timeDiff < oneMinute) {
      const seconds = Math.floor(timeDiff / oneSecond);
      return (
        <span>
          {seconds === 1 ? `${seconds} second ago` : `${seconds} seconds ago`}
        </span>
      );
    } else if (timeDiff < oneHour) {
      const minutes = Math.floor(timeDiff / oneMinute);
      return (
        <span>
          {minutes === 1 ? `${minutes} minute ago` : `${minutes} minutes ago`}
        </span>
      );
    } else if (timeDiff < oneDay) {
      const hours = Math.floor(timeDiff / oneHour);
      return (
        <span>{hours === 1 ? `${hours} hour ago` : `${hours} hours ago`}</span>
      );
    } else {
      const days = Math.floor(timeDiff / oneDay);
      return <span>{days === 1 ? `${days} day` : `${days} days`}</span>;
    }
  };